import { useState } from 'react'
import {
  PERSONAL_DATA_AGREEMENT_URL,
  SMS_CODE_LENGTH,
} from '~/shared/config/constants'
import { formatPhoneNumber } from '~/shared/lib/utils'
import { Button } from '~/shared/ui/Buttons'
import { VerificationFieldElement } from '~/shared/ui/form'
import { RepeatCode } from '~/shared/ui/RepeatCode'
import { TIMER_REGISTRATION, TIMER_REGISTRATION_TIME } from '../constant'
import { Description, CodeWrapper, Wrapper } from './styled'

type ConfirmCodeStepProps = {
  onOk: (code: string) => void
  onCodeRepeat?: () => void
  isSubmitting: boolean
  phone?: string
}

export function ConfirmCodeStep({
  onOk,
  onCodeRepeat,
  isSubmitting,
  phone,
}: ConfirmCodeStepProps) {
  const [code, setCode] = useState<string>()

  const handleCodeChange = (code: string) => {
    setCode(code)
    if (code.length === SMS_CODE_LENGTH) {
      onOk(code)
    }
  }

  const handleOnOk = () => {
    onOk(code as string)
  }

  return (
    <Wrapper>
      <CodeWrapper>
        <Description>
          Введите код, который придет на ваш номер
          <br />
          {phone && formatPhoneNumber(phone)}, <br /> чтобы получить полный
          доступ к приложению
        </Description>
        <VerificationFieldElement onChange={handleCodeChange} />
        <br />

        <Description>
          При подтверждении телефона кодом вы соглашаетесь на обработку
          персональных данных
        </Description>

        <Button
          href={PERSONAL_DATA_AGREEMENT_URL}
          target='_blank'
          variant='textLink'
          contentProps={{ style: { padding: 0 } }}
        >
          Согласие на обработку персональных данных
        </Button>
        <br />

        <Button
          onClick={handleOnOk}
          loading={isSubmitting}
          fullWidth
          variant='limeFlooded'
          size='large'
          disabled={code?.length !== 4}
        >
          Отправить
        </Button>
        <br />
        <RepeatCode
          onCodeRepeat={onCodeRepeat}
          time={TIMER_REGISTRATION_TIME}
          storageKey={TIMER_REGISTRATION}
        />
      </CodeWrapper>
    </Wrapper>
  )
}
